// TestBookMockExam.jsx
import React, { useRef, useCallback, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import './styles/MCQPractice.css';
import OtherCertificateImage from '../../certificates/Think5WhysCertTemplateDec24.png';

const TestBookMockExam = () => {
    const authState = useSelector(state => state.authReducer);
    const [fetchData, { loading }] = useFetch();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // Important - useEffect to stop infinite rendering
    }, [location.state.setId]);

    const [setId, setSetId] = useState(location.state.setId);
    const [setTitle, setSetTitle] = useState(location.state.setTitle);
    const [seriesId, setSeriesId] = useState(location.state.seriesId);
    const [seriesTitle, setSeriesTitle] = useState(location.state.seriesTitle);
    const [examId, setExamId] = useState(location.state.examId);
    const [examTitle, setExamTitle] = useState(location.state.examTitle);
    const [examType, setType] = useState(location.state.examType);
    const [timeLimitInMin, setTimeLimitInMin] = useState(location.state.timeLimitInMin);
    const [isRepeatExam, setIsRepeatExam] = useState(location.state.isRepeatExam);

    const [repeatExamId, setRepeatExamId] = useState(null);
    const [questions, setQuestions] = useState([]);
    const [timer, setTimer] = useState(0);
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [answers, setAnswers] = useState([]);
    const [certificate, setCertificate] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState(Array(questions.length).fill(null));

    const [savedToDB, setSavedToDB] = useState(false);

    const [totalCorrectAnswers, setTotalCorrectAnswers] = useState(0);
    const [fullMarks, setFullMarks] = useState(0);
    const [totalMarksObtained, setTotalMarksObtained] = useState(0);
    const [percentage, setPercentage] = useState(0);
    const [certificateNumber, setCertificateNumber] = useState(null);
    
    const [certificateSetup, setCertificateSetup] = useState(null);

    useEffect(() => {
        if (!authState.isLoggedIn) return;
        fetchQuestions();
    }, [authState]);


    const fetchQuestions = useCallback(() => {
        if (!setId) return;
        const config = {
            url: `/ttbquestionmaster/forttbsetid`,
            method: "post",
            headers: { Authorization: authState.token },
            data: {setId: setId}
        };
        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response && Array.isArray(response.questionlist)) {
                    setQuestions(response.questionlist);
                    getCertificateSetup(examId);
                } else {
                    console.error("Invalid response format: Assignment not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching Assignments:", error);
            });
    }, [fetchData, setId]);

    useEffect(() => {

    }, [questions]);

    useEffect(() => {
        if (submitted) {
            return;
        }
        setStartTime(new Date());
        const intervalId = setInterval(() => {
            setTimer(prevTimer => prevTimer + 1);
        }, 1000);

        return () => clearInterval(intervalId);
    }, [submitted]);

    const allQuestionsAnswered = selectedOptions.every(option => option !== null);

    const handleOptionChange = (index, option) => {
        const newSelectedOptions = [...selectedOptions];
        newSelectedOptions[index] = option;
        setSelectedOptions(newSelectedOptions);
    };

    const [answeredAllBeforeSubmit, setAnsweredAllBeforeSubmit] = useState(false);
    const [answerAllBeforeSubmitMsg, setAnswerAllBeforeSubmitMsg] = useState(null);

    const handleSubmit = () => {
        if (submitted) {
            return;
        }
        const answeredQuestions = selectedOptions.filter(option => option !== null);
        if (answeredQuestions.length !== questions.length) {
            setAnswerAllBeforeSubmitMsg("Complete your exam. Give all the answers before submitting it.");
            return;
        }
        setAnsweredAllBeforeSubmit(true);
        setEndTime(new Date());
        setSubmitted(true);
        showAnswers();
    };

    const generateCertificateNumber = () => {
        const currentDate = new Date();
        const certificateNumber = currentDate.getFullYear().toString().padStart(4, '0') + 
            (currentDate.getMonth() + 1).toString().padStart(2, '0') + 
            currentDate.getDate().toString().padStart(2, '0') + 
            currentDate.getHours().toString().padStart(2, '0') + 
            currentDate.getMinutes().toString().padStart(2, '0') + 
            currentDate.getSeconds().toString().padStart(2, '0') + 
            currentDate.getMilliseconds().toString().padStart(3, '0'); 
            setCertificateNumber(certificateNumber);
    }

    const getCertificateSetup = async (examId) => {
        const config = {
            url: "/ttbmyexamsets/certificatesetup",
            method: "post",
            headers: { Authorization: authState.token },
            data: { examId: examId },
        };
    
        // console.log("getCertificateDetails config: ", config);
    
        try {
            fetchData(config, { showSuccessToast: false })
                .then((response) => {
                    // console.log("getCertificateDetails response: ", response);

                    if (response && response.certificateSetup) {
                        setCertificateSetup(response.certificateSetup);
                        setCertificate({
                            certificateNumber: certificateNumber, 
                            certificateDate: new Date(),
                            certificateName: authState.user.name,
                            certificateTitle: response.certificateSetup.certificateTitle,
                            certificateDesc: response.certificateSetup.certificateDesc,
                            certificateTemplate: response.certificateSetup.certificateTemplate,
                            signName1: response.certificateSetup.signName1,
                            signDesig1: response.certificateSetup.signDesig1,
                            signEntity1: response.certificateSetup.signEntity1,
                            signImage1: response.certificateSetup.signImage1,
                            isSignatory2: response.certificateSetup.isSignatory2,
                            signName2: response.certificateSetup.signName2,
                            signImage2: response.certificateSetup.signImage2,
                            signDesig2: response.certificateSetup.signDesig2,
                            signEntity2: response.certificateSetup.signEntity2,
                            hasSponsor: response.certificateSetup.hasSponsor,
                            sponsorName: response.certificateSetup.sponsorName,
                            sponsorLogo: response.certificateSetup.sponsorLogo,
                            certificateRemarks:
                                "Full Marks: " +
                                fullMarks +
                                " Number of Questions: " +
                                questions.length +
                                " Correct Answer: " +
                                totalCorrectAnswers +
                                " Wrong Answer: " +
                                questions.length-totalCorrectAnswers +
                                " Marks Obtained: " +
                                totalMarksObtained +
                                " Percent: " +
                                percentage +
                                "%",
                        });
                    } else {
                        console.error("Certificate setup not found in response.");
                    }
                })
                .catch((error) => {
                    console.error("Error in fetchData call:", error);
                });
        } catch (error) {
            console.error("Error fetching certificate details:", error);
        }
    };
    
    
    useEffect(() => {
        if (certificateNumber) {
            setCertificate({
                certificateNumber: certificateNumber,
                certificateDate: new Date(),
                certificateName: authState.user.name,
                certificateDesc: examTitle,
                certificateTitle: certificateSetup.certificateTitle,
                certificateDesc: certificateSetup.certificateDesc,
                certificateTemplate: certificateSetup.certificateTemplate,
                signName1: certificateSetup.signName1,
                signDesig1: certificateSetup.signDesig1,
                signEntity1: certificateSetup.signEntity1,
                signImage1: certificateSetup.signImage1,
                isSignatory2: certificateSetup.isSignatory2,
                signName2: certificateSetup.signName2,
                signImage2: certificateSetup.signImage2,
                signDesig2: certificateSetup.signDesig2,
                signEntity2: certificateSetup.signEntity2,
                hasSponsor: certificateSetup.hasSponsor,
                sponsorName: certificateSetup.sponsorName,
                sponsorLogo: certificateSetup.sponsorLogo,
                certificateRemarks: "Marks: " + totalMarksObtained + " / " + fullMarks + " ( " + percentage.toFixed(2) + " % )" +
                                    " [#Questions: " + questions.length + 
                                    " ,Correct Answer: " + totalCorrectAnswers + 
                                    " ,Wrong Answer: " + (questions.length-totalCorrectAnswers) + ']'
            });
        }
        // console.log('Certificate state:', certificate);
    }, [certificateNumber, authState.user.name, examTitle]);
   
    const showAnswers = () => {
        const correctCount = questions.reduce((count, question, index) => {
            const correctAnswer = question.mcqCorrectAnswer;
            const userAnswer = selectedOptions[index];
            if (userAnswer === correctAnswer) {
                return count + 1;
            }
            return count;
        }, 0);

        const totalQuestions = questions.length;

        let totalMarksObtained = 0;
        let fullMarks = 0;
        let totalCorrectAnswers = 0;

        const answeredQuestions = questions.map((question, index) => {
            const correctAnswer = question.mcqCorrectAnswer;
            const userAnswer = selectedOptions[index];
            const isCorrect = userAnswer === correctAnswer;
            const correctAnswerPoints = question.correctAnswerPoints;
            const wrongAnswerPoints = question.wrongAnswerPoints;
            const isCorrectAnswer = isCorrect ? 1 : 0;
            totalCorrectAnswers += isCorrectAnswer;
            const marksObtained = isCorrect ? question.correctAnswerPoints : question.wrongAnswerPoints;
            totalMarksObtained += marksObtained;
            fullMarks += question.correctAnswerPoints;
            return { question, correctAnswer, userAnswer, marksObtained, correctAnswerPoints, wrongAnswerPoints };
        });
        setAnswers(answeredQuestions);
        setTotalCorrectAnswers(totalCorrectAnswers);
        setFullMarks(fullMarks);
        setTotalMarksObtained(totalMarksObtained);
        const calculatedPercentage = (totalMarksObtained / fullMarks) * 100;
        setPercentage(calculatedPercentage);
        generateCertificateNumber();
        setCertificate();
    };

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSaveExam = () => {
        saveExamToDB();
    };

    const saveExamToDB = async () => {
        const userId = authState.user._id;
        const numberOfQuestions = questions.length;
        const totalIncorrectAnswers = numberOfQuestions - totalCorrectAnswers;
        // const certificateDetails = getCertificateDetails(examId);
        const requestData = {
            setQuestionType: "MCQ",
            userId: userId,
            setId: setId,
            setTitle: setTitle,
            seriesId: seriesId,
            seriesTitle: seriesTitle,
            examId: examId,
            examTitle: examTitle,
            examType: examType,
            isRepeatExam: isRepeatExam,
            repeatExamId: repeatExamId,
            numberOfQuestions: numberOfQuestions,
            correctAnswers: totalCorrectAnswers,
            incorrectAnswers: totalIncorrectAnswers,
            dateExam: startTime,
            ExamTimeStarted: startTime,
            ExamTimeEnded: endTime,
            marksObtained: totalMarksObtained,
            percentage: percentage,
            totalMarksObtained: totalMarksObtained,
            fullMarks: fullMarks,
            answers: answers,
            remarks: "",
            tags: "",
            ExamLocation: "",
            mentorName: "",
            mentorRemarks: "",
            selfFeedback: "",
            think5whysRcaId: "",
            locationIP: "",
            hasExplanation: 0,
            isActive: 1,
            isDeleted: 0,
            createBy: userId,
            timeTaken: timer * 1000,
            timeLimit: timeLimitInMin,
            certificate: certificate,
            practiceCode:  generatePracticeCode(),
        };
        // console.log('Exam data to be saved:', requestData);
        try {
            const config = { url: `/ttbsaveexam/ttbmock`, method: "post", data: requestData, headers: { Authorization: authState.token } };
            await fetchData(config);
            setSavedToDB(true);
        } catch (error) {
            console.error('An error occurred while fetching data:', error);
        }
    };

    const generatePracticeCode = () => {
        const now = new Date();
        const dd = String(now.getDate()).padStart(2, '0');
        const mm = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const yyyy = now.getFullYear();
        const hh = String(now.getHours()).padStart(2, '0');
        const min = String(now.getMinutes()).padStart(2, '0');
        const ss = String(now.getSeconds()).padStart(2, '0');
        const practiceCode = `${dd}${mm}${yyyy}${hh}${min}${ss}`;
      
        return practiceCode;
      };

    const handleViewCertificate = () => {
        drawCertificate();
    };

    // Function to wrap text
    function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
        const words = text.split(' ');
        let line = '';
        const lines = [];

        for (let i = 0; i < words.length; i++) {
            const testLine = line + words[i] + ' ';
            const metrics = ctx.measureText(testLine);
            const testWidth = metrics.width;

            if (testWidth > maxWidth && i > 0) {
                lines.push(line);
                line = words[i] + ' ';
            } else {
                line = testLine;
            }
        }

        lines.push(line);

        // Center text vertically
        const totalHeight = lines.length * lineHeight;
        const yStart = y - totalHeight / 2;

        lines.forEach((line, index) => {
            const lineWidth = ctx.measureText(line).width;
            const xPosition = (canvasWidth - lineWidth) / 2; // Center horizontally
            ctx.fillText(line, xPosition, yStart + (index * lineHeight));
        });
    }

    const drawCertificate = () => {
        const canvas = document.getElementById('certificateCanvas');
        const ctx = canvas.getContext('2d');
        const canvasHeight = canvas.height;
        const canvasWidth = canvas.width;
        const date = new Date(certificate.certificateDate);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;

        let fontSize = 18;
        const textName = certificate.certificateName;
        const textNameWidth = ctx.measureText(textName).width;
        const xCoordinateName = (canvasWidth - textNameWidth) / 2;
        const adjustedXCoordinateName = xCoordinateName - (textNameWidth / 2) + (fontSize / 2);

        fontSize = 14;
        const textExamTitle = certificate.certificateTitle;
        const textExamTitleWidth = ctx.measureText(textExamTitle).width;
        const xCoordinateExamTitle = (canvasWidth - textExamTitleWidth) / 2;
        const adjustedXCoordinateExamTitle = xCoordinateExamTitle - (textExamTitleWidth / 2) + (fontSize / 2);

        fontSize = 12;
        const lineHeight = fontSize * 1.5; 
        const maxWidth = canvasWidth - 40; 
        ctx.font = `${fontSize}px Arial`;        
        const certificateRemarksWidth = ctx.measureText(certificate.certificateRemarks).width;
        const xCoordinateCertificateRemarks = (canvasWidth - certificateRemarksWidth) / 2;
        const adjustedXCoordinateExamRemarks = xCoordinateCertificateRemarks - (certificateRemarksWidth / 2) + (fontSize / 2);

        fontSize = 10;
        ctx.font = `${fontSize}px Arial`;        
        const certificateSignatoryWidth = ctx.measureText(certificate.signName2).width;
        const xCoordinateCertificateSignatory = (canvasWidth - certificateSignatoryWidth) / 2;
        const adjustedXCoordinateSignatory = xCoordinateCertificateSignatory - (certificateSignatoryWidth / 2) + (fontSize / 2);

        const certificateImage = new Image();
        const signatoryImage2 = new Image();
        const sponsorLogo = new Image();
        certificateImage.onload = function () {
            ctx.drawImage(certificateImage, 0, 0);
            ctx.fillStyle = 'black';
            ctx.font = '12px Arial';
            ctx.fillText(certificateNumber, 480, 35);
            ctx.font = '18px Arial';
            ctx.fillText(certificate.certificateName, adjustedXCoordinateName, 260);
            ctx.font = '14px Arial';
            ctx.fillText(certificate.certificateTitle, adjustedXCoordinateExamTitle, 290);
            ctx.font = '12px Arial';
            ctx.fillText(certificate.certificateRemarks, 165, 340);
            ctx.font = '12px Arial';
            ctx.fillText(formattedDate, 165, 430);
            if(certificate.isSignatory2 === 1) {
                const signatoryImage2 = new Image();
                signatoryImage2.onload = function() {
                    ctx.drawImage(signatoryImage2, adjustedXCoordinateSignatory, 380);
                    ctx.font = '10px Arial';
                    ctx.fillText(certificate.signName2, adjustedXCoordinateSignatory, 450);
                    ctx.font = '10px Arial';
                    ctx.fillText(certificate.signDesig2, adjustedXCoordinateSignatory, 470);
                };
                signatoryImage2.src = `/certificates/${certificate.signImage2}`;
            }
            if(certificate.hasSponsor === 1) {
                const sponsorLogo = new Image();
                sponsorLogo.onload = function() {
                    ctx.drawImage(sponsorLogo, 600, 250);
                };
                sponsorLogo.src = `/certificates/${certificate.sponsorLogo}`;
            }
        };
        certificateImage.src = `/certificates/${certificate.certificateTemplate}`;
    };

    const handleClose = () => {
        navigate('/testbook-mockexamlist');
    };

    const getOptionValue = (options, key) => {
        return options[key];
    };

    const isSubmitDisabled = selectedOptions.includes(null);

    const formatTime = (timeInSeconds) => {
        const hours = Math.floor(timeInSeconds / 3600);
        const minutes = Math.floor((timeInSeconds % 3600) / 60);
        const seconds = timeInSeconds % 60;

        return `${hours}Hr ${minutes}Min ${seconds}Sec`;
    };

    return (
        <MainLayout> 
            <div className="min-h-screen py-8 bg-gradient-to-r from-gray-500 via-gray-600 to-gray-800 mt-12 mb-2 ">
                <h3 className='text-xl font-bold text-white text-center mb-4'>Mock Certification Exams</h3>
                <div className="practice-test-container max-w-4xl mx-auto mt-6 p-6 bg-gray-800 rounded-lg shadow-lg">
                    <p className='text-white'>Welcome, {authState.user && authState.user.name ? authState.user.name : 'Guest'}</p>
                    <p className='text-white'>Exam: {examTitle}-{examType}</p>
                    <p className='text-white'>Number of Questions: {questions.length}</p>               
                    <p className='text-white'>Your Exam Begins at: {startTime && startTime.toLocaleString()}</p>
                    <p className='text-yellow-300'>Time Limit: {timeLimitInMin} Minutes</p>
                    <p className='text-white'>Time Taken: {formatTime(timer)}</p><br /><br />
                    {questions.length<1 && (
                        <>
                            <p className='mt-8 mb-8 text-xl text-orange-400'>Questions are not setup yet for {examTitle}!!</p>
                        </>
                    )}
                </div>
                {questions.map((question, index) => (
                    <div key={question._id} className="question-item bg-gray-700 p-4 mb-4 rounded-md shadow-md mx-4">
                        <p className="question-number text-white">Question: {index + 1}
                            <span className="text-gray-500 ml-4">
                                [Correct Answer : {question.correctAnswerPoints} marks, Wrong Answer: {question.wrongAnswerPoints} marks]
                            </span>
                        </p>
                        <p className="question-text text-white">Question: {question.question}</p>
                        <form>
                            <div>
                                <input
                                    type="radio"
                                    id={`${question._id}-A`}
                                    name={`question_${index}`}
                                    value="A"
                                    onChange={() => handleOptionChange(index, 'A')}
                                />
                                <label htmlFor={`${question._id}-A`}>{question.mcqOptions[0].A}</label>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    id={`${question._id}-B`}
                                    name={`question_${index}`}
                                    value="B"
                                    onChange={() => handleOptionChange(index, 'B')}
                                />
                                <label htmlFor={`${question._id}-B`}>{question.mcqOptions[0].B}</label>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    id={`${question._id}-C`}
                                    name={`question_${index}`}
                                    value="C"
                                    onChange={() => handleOptionChange(index, 'C')}
                                />
                                <label htmlFor={`${question._id}-C`}>{question.mcqOptions[0].C}</label>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    id={`${question._id}-D`}
                                    name={`question_${index}`}
                                    value="D"
                                    onChange={() => handleOptionChange(index, 'D')}
                                />
                                <label htmlFor={`${question._id}-D`}>{question.mcqOptions[0].D}</label>
                            </div>
                        </form>
                    </div>
                ))}
                { !answeredAllBeforeSubmit && (
                    <div className="text-red-600">
                        {answerAllBeforeSubmitMsg}
                    </div>
                )}
                <button
                    className="save-practice-button"
                    onClick={handleSubmit}
                    // disabled={!allQuestionsAnswered }
                    disabled={questions.length<1 }

                >
                    Submit
                </button>
                {submitted && answers.length > 0 && (
                    <div className="submission-details text-white mb-4">
                        <p>{authState.user && authState.user.name ? authState.user.name : 'Guest'} Your Exam Is Over.</p>
                        <p>Start Time: {startTime && startTime.toLocaleString()}</p>
                        <p>End Time: {endTime && endTime.toLocaleString()}</p>
                        <p>Time Taken: {formatTime(timer)}</p>
                    </div>
                )}
                {submitted && (
                    <button
                        className="save-practice-button"
                        onClick={handleSaveExam}
                        disabled={savedToDB}
                    >
                        View Result
                    </button>
                )}
                {submitted && savedToDB && (
                    <div className="additional-stats text-yellow-300">
                        <p>Number of Questions: {questions.length}</p>
                        <p>Correct Answers: {answers.filter(answer => answer.userAnswer === answer.correctAnswer).length}</p>
                        <p>Incorrect Answers: {answers.filter(answer => answer.userAnswer !== answer.correctAnswer).length}</p>
                        <p>Full Marks: {fullMarks}</p>
                        <p>Marks Obtained: {totalMarksObtained}</p>
                        <p>Percent: {percentage}%</p>
                        <br />
                    </div>
                )}
                {submitted && savedToDB && (
                    <div className="progress-container">
                        <div className="progress-bar">
                            <div className="progress" style={{ width: `${percentage}%` }}>
                                {`${percentage}%`}
                            </div>
                        </div>
                    </div>
                )}
                {/* {submitted && savedToDB  && answers.map((answer, index) => (
                    <div key={index} className="answer-item text-white">
                        <p className="question-info text-yellow-300">Question {index + 1}: {answer.question.question}</p>
                        <p className="user-answer">
                            Your Answer:
                            <span className={answer.userAnswer === answer.correctAnswer ? 'correct-answer' : 'incorrect-answer'}>
                                {answer.userAnswer} ({getOptionValue(answer.question.mcqOptions[0], answer.userAnswer)})
                            </span>
                        </p>
                        {answer.userAnswer !== answer.correctAnswer && (
                            <p className="correct-answer">
                                Correct Answer: <span className="correct-answer-text">
                                    {answer.correctAnswer} ({getOptionValue(answer.question.mcqOptions[0], answer.correctAnswer)})
                                </span>
                            </p>
                        )}
                        <p className="question-info">Marks Obtained: {answer.marksObtained}</p>
                        <p className="question-info text-gray-400">[Marks for correct answer: <strong>{answer.correctAnswerPoints}</strong>, Marks for wrong answer: <strong>{answer.wrongAnswerPoints}]</strong></p>
                    </div>
                ))} */}
                {submitted && savedToDB && (
                    <div className='flex flex-col justify-center mt-4'>
                        <button className="flex items-center save-practice-button bg-purple-600" onClick={handleViewCertificate}>View Certificate</button>
                        <canvas className="flex items-center" id="certificateCanvas" width="800" height="600"></canvas>
                    </div>
                )}
                {submitted && savedToDB && (
                    <button className="save-practice-button" onClick={handleClose}>Close</button>
                )}
            </div>
        </MainLayout>
    );
};

export default TestBookMockExam;
